import { CartAlertToaster, Img } from "components";
import Account from "./Account";
import DeliveryMode from "./DeliveryMode";
import DeliveryDateTime from "./DeliveryDateTime";
import Payment from "./Payment";
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getOrderData, updateOrderData } from "redux/reducers/orderData";
import { useAppFont } from "utils/helper/useAppFont";
import { useTranslation } from "react-i18next";

const STEPS = {
  ACCOUNT: 1,
  DELIVERY: 2,
  DATETIME: 3,
  PAYMENT: 4,
};

const CartProductStep = (props) => {
  const {
    // orderData,
    cartData,
    addressList,
    zoneList,
    occasionOptions,
    prepTime,
    cartItemError,
    isEventSent,
    setIsEventSent,
    sendCheckoutGaEvent,
    onViewOrderSummary,
  } = props;

  const [cartAlreatToast, setCartAlreatToast] = useState(false);
  const { t } = useTranslation();
  const [activeStep, setActiveStep] = useState(STEPS.ACCOUNT);
  const orderData = useSelector(getOrderData);
  const dispatch = useDispatch();
  const { interClass, headingClass } = useAppFont();

  const isReservationFlow = !!orderData?.isReservationFlow;
  // ─────────────────────────────────────────────────────────────────────────

   useEffect(() => {
    if (orderData?.accountForm === "completed") {
      if (orderData?.pageStep === 4) {
        setActiveStep(STEPS.PAYMENT);
      } else if (orderData?.pageStep === 3) {
        setActiveStep(STEPS.DATETIME);
      } else if (orderData?.pageStep === 2) {
        setActiveStep(STEPS.DELIVERY);
      } else if (orderData?.delivery_mode) {
        setActiveStep(STEPS.DATETIME);
      } else {
        setActiveStep(STEPS.DELIVERY);
      }
    } else {
      setActiveStep(STEPS.ACCOUNT);
    }
  }, [orderData?.accountForm, orderData?.delivery_mode, orderData?.pageStep])

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [orderData?.pageStep]);

   const isStepVisible = (step) => {
    if (isReservationFlow) {
      return step === STEPS.PAYMENT;
    }
    // ─────────────────────────────────────────────────────────────────────

    switch (step) {
      case STEPS.ACCOUNT:
        return orderData?.pageStep === 1 || orderData?.accountForm !== "completed";
        
      case STEPS.DELIVERY:
      return (
        orderData?.accountForm === "completed" &&
        orderData?.pageStep === 2
      );
        
      case STEPS.DATETIME:
      return (
        orderData?.accountForm === "completed" &&
        orderData?.delivery_mode &&
        orderData?.delivery_mode !== "buying_for_love" &&
        orderData?.pageStep === 3
      );
        
      case STEPS.PAYMENT:
        if (orderData?.delivery_mode === "buying_for_love") {
          return (
            orderData?.accountForm === "completed" && 
            orderData?.delivery_mode &&
            orderData?.pageStep === 4
          );
        }
        return (
          orderData?.accountForm === "completed" &&
          orderData?.delivery_mode &&
          orderData?.pageStep === 4
        );
        
      default:
        return false;
    }
  };
  const isCompleted = (stepId) => {
    if (isReservationFlow) {
      if (stepId === STEPS.ACCOUNT) return true;
      if (stepId === STEPS.DELIVERY) return true;
      if (stepId === STEPS.DATETIME) return true;
      if (stepId === STEPS.PAYMENT) return false;
    }
    switch (stepId) {
      case STEPS.ACCOUNT:
        return orderData?.accountForm === "completed";

      case STEPS.DELIVERY:
        return !!orderData?.delivery_mode && orderData?.pageStep > 2;

      case STEPS.DATETIME:
        if (orderData?.delivery_mode === "buying_for_love") {
          return orderData?.pageStep >= 4;
        }
        return (
          orderData?.pageStep >= 4 &&
          orderData?.deliveryDateTimeActiveTab !== undefined
        );

      case STEPS.PAYMENT:
        return false;

      default:
        return false;
    }
  };

  const getCurrentStepNumber = () => {
    return activeStep;
  };

  const getCurrentStepInfo = () => {
    const steps = {
      [STEPS.ACCOUNT]: { 
        name: "Account", 
        icon: "images/person.svg",
        activeIcon: "images/check.svg"
      },
      [STEPS.DELIVERY]: { 
        name: "Delivery", 
        icon: "images/mapLocation.png",
        activeIcon: "images/mapLocation.png"
      },
      [STEPS.DATETIME]: { 
        name: "Date & Time", 
        icon: "images/dateTime.png",
        activeIcon: "images/dateTime.png"
      },
      [STEPS.PAYMENT]: { 
        name: "Payment", 
        icon: "images/cartPayment.png",
        activeIcon: "images/cartPayment.png"
      },
    };
    
    const currentStep = steps[activeStep] || steps[STEPS.ACCOUNT];
    const isCompletedStep = activeStep === STEPS.ACCOUNT && orderData?.accountForm === "completed";
    
    return {
      ...currentStep,
      displayIcon: isCompletedStep ? currentStep.activeIcon : currentStep.icon
    };
  };

  return (
    <div
      className="relative flex flex-col flex-1 w-full gap-y-8 sm:order-2 sm:pl-0"
      onClick={(e) => {
        if (cartItemError) {
          setCartAlreatToast(true);
          setTimeout(() => {
            setCartAlreatToast(false);
          }, [6000]);
        }
      }}
    >
      {cartAlreatToast && cartItemError ? (
        <CartAlertToaster setCartAlreatToast={setCartAlreatToast} />
      ) : (
        ""
      )}
      <div className={cartItemError ? `pointer-none` : "no-error-in-cart-items"}>
  
  {/* SINGLE CART */}
  <div className="bg-white-A700 rounded-md shadow-sm overflow-hidden">

    <div className="hidden sm:block px-6 sm:px-3 py-4 border-b border-gray-200">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 flex items-center justify-center bg-gray-200 border border-2 rounded-full flex-shrink-0">
            <Img
              src={getCurrentStepInfo().displayIcon}
              alt={getCurrentStepInfo().name}
              className="w-8 h-8 object-contain"
            />
          </div>
          
          <div className="flex flex-col">
            <span className={`text-[#1A1A1A] text-center ${headingClass} text-[12px] font-normal leading-[16px]`}>
              {getCurrentStepInfo().name}
            </span>
            <span className={`text-[#6D737E] ${interClass} text-xs font-normal leading-tight text-[12px] font-normal leading-[16px]`}>
              {isReservationFlow ? "Reservation Payment" : `Step ${getCurrentStepNumber()} of 4`}
            </span>
          </div>
        </div>
        
        <button
          onClick={() => onViewOrderSummary && onViewOrderSummary()}
          className={`flex items-center gap-2 text-[#1A1A1A] text-center ${interClass} text-[12px] font-normal leading-[16px] flex-shrink-0`}
        >
          <span className={`text-[#1A1A1A] ${interClass} text-[12px] font-normal leading-[16px]`}>
            {t("viewOrderSummary")}
          </span>
          <Img
            src="/images/DownArrow.svg"
            alt="arrow"
            className="w-4 h-4"
          />
        </button>
      </div>
    </div>

    {/* TOP STEPPER (INSIDE CART) - Hidden on mobile (< 640px), visible on desktop (>= 640px) */}
    <div className="block sm:block px-6 py-4 border-b border-gray-200">
      <div className="relative flex items-center justify-between">

        {/* background line */}
        <div className="absolute top-[28px] left-6 right-6 h-[2px] bg-gray-200" />

        {/* active line — reservation flow: full width since steps 1-3 done */}
        <div
          className="absolute top-[28px] left-6 h-[2px] bg-[#771237] transition-all duration-300"
          style={{
            width: isReservationFlow
              ? "100%"                           // all steps visually complete
              : activeStep === STEPS.ACCOUNT
              ? "0%"
              : activeStep === STEPS.DELIVERY
              ? "33%"
              : activeStep === STEPS.DATETIME
              ? "66%"
              : "100%",
          }}
        />

        {[
          { id: STEPS.ACCOUNT, label: (t("account")), icon: "images/check.svg" },
          { id: STEPS.DELIVERY, label: (t("delivery")), icon: "images/mapLocation.png" },
          { id: STEPS.DATETIME, label: (t("dateTime")), icon: "images/dateTime.png" },
          { id: STEPS.PAYMENT, label: (t("payment")), icon: "images/cartPayment.png" },
        ].map((step) => {
          const completed = isReservationFlow
            ? step.id < STEPS.PAYMENT
            : isCompleted(step.id);
          const isActiveOrDone = completed || activeStep === step.id;

          return (
            <div
              key={step.id}
              onClick={() => {
                if (isReservationFlow) return;

                const stepCompleted = isCompleted(step.id);
                
                if (stepCompleted || step.id === activeStep) {
                  setActiveStep(step.id);
                  
                  let newPageStep = step.id;
                  if (step.id === STEPS.ACCOUNT) {
                    newPageStep = 1;
                  } else if (step.id === STEPS.DELIVERY) {
                    newPageStep = 2;
                  } else if (step.id === STEPS.DATETIME) {
                    if (!orderData?.delivery_mode) {
                      newPageStep = 2;
                      setActiveStep(STEPS.DELIVERY);
                    } else {
                      newPageStep = 3;
                    }
                  } else if (step.id === STEPS.PAYMENT) {
                    if (!orderData?.deliveryDateTimeActiveTab && orderData?.delivery_mode !== "buying_for_love") {
                      newPageStep = 3;
                      setActiveStep(STEPS.DATETIME);
                    } else {
                      newPageStep = 4;
                    }
                  }
                  
                  dispatch(
                    updateOrderData({
                      ...orderData,
                      pageStep: newPageStep,
                    })
                  );
                }
              }}
              className={`relative z-10 flex flex-col items-center transition-opacity
                ${isReservationFlow
                  ? step.id === STEPS.PAYMENT ? 'cursor-default' : 'cursor-default opacity-80'
                  : isActiveOrDone || completed
                    ? 'cursor-pointer hover:opacity-80' 
                    : 'cursor-not-allowed opacity-60'}`}
            >
              {/* ICON WRAPPER */}
              <div
                className={`flex items-center justify-center rounded-full transition-all
                  ${
                    isActiveOrDone
                      ? "bg-[#771237]"
                      : "bg-white border border-gray-300"
                  }`}
                style={{
                  width: isActiveOrDone ? "56px" : "48px",
                  height: isActiveOrDone ? "56px" : "48px",
                  padding: isActiveOrDone ? "11.2px" : "8px",
                }}
              >
                <Img
                  src={completed ? "images/check.svg" : step.icon}
                  alt={step.label}
                  className="w-[32px] h-[32px] flex-shrink-0"
                />
              </div>

              {/* LABEL */}
              <span
                className={`mt-2 text-xs font-medium
                  ${
                    isActiveOrDone ? "text-[#771237]" : "text-gray-400"
                  }`}
              >
                {step.label}
              </span>
            </div>
          );
        })}
      </div>
    </div>

        {isStepVisible(STEPS.ACCOUNT) && (
        <div className="relative bg-white-A700 py-[18px] px-6 xs:px-4">
          {/* <div className="absolute bg-red-100 flex h-9 items-center justify-center -left-7 rtl:-left-[auto] rtl:-right-7 p-1.5 top-6 w-9 z-[1] step-icon active">
            <Img className="h-6" src="images/person.svg" alt="user" />
          </div> */}
          <div className="absolute border-l-2 mt-2 border-gray-300 border-dashed w-px -left-3 rtl:-left-[auto] rtl:-right-3 z-[0] step-line success"></div>
          <Account addressList={addressList} />
        </div>
        )}
        {isStepVisible(STEPS.DELIVERY) && (
        <div className="relative bg-white-A700 py-[18px] px-6 xs:px-4">
          {/* <div className="absolute bg-white-A700 flex h-9 items-center justify-center -left-7 rtl:-left-[auto] rtl:-right-7 p-1.5 top-6 shadow-bs6 w-9 z-[1] step-icon active">
            <Img className="h-6" src="images/location_on.svg" alt="location" />
          </div> */}
          <div className="absolute border-l-2 mt-2 border-gray-300 border-dashed w-px -left-3 rtl:-left-[auto] rtl:-right-3 z-[0] step-line"></div>
          <DeliveryMode
            addressList={addressList}
            zoneList={zoneList}
            occasionOptions={occasionOptions}
            isEventSent={isEventSent}
            setIsEventSent={setIsEventSent}
            sendCheckoutGaEvent={sendCheckoutGaEvent}
          />
        </div>
        )}
        
        {isStepVisible(STEPS.DATETIME) && orderData?.delivery_mode !== "buying_for_love" && (
          <div className="relative bg-white-A700 py-[18px] px-6 xs:px-4">
            {/* <div className="absolute bg-white-A700 flex h-9 items-center justify-center -left-7 rtl:-left-[auto] rtl:-right-7 p-1.5 top-6 shadow-bs6 w-9 z-[1] step-icon">
              <Img className="h-6" src="images/event_note.svg" alt="calendar" />
            </div> */}
            <div className="absolute border-l-2 mt-2 border-gray-300 border-dashed w-px -left-3 rtl:-left-[auto] rtl:-right-3 z-[0] step-line"></div>
            <DeliveryDateTime orderDetails={cartData} prepTime={prepTime} />
          </div>
        )}
      
        {isStepVisible(STEPS.PAYMENT) && (
        <div className="relative bg-white-A700 pt-[18px]">
          {/* <div className="absolute bg-white-A700 flex h-9 items-center justify-center -left-7 rtl:-left-[auto] rtl:-right-7 p-1.5 top-6 shadow-bs6 w-9 z-[1] step-icon">
            <Img
              className="h-6"
              src="images/account_balance_wallet.svg"
              alt="camera"
            />
          </div> */}
          <Payment
            cartData={cartData}
            isEventSent={isEventSent}
            setIsEventSent={setIsEventSent}
            sendCheckoutGaEvent={sendCheckoutGaEvent}
          />
        </div>
        )}
      </div>
    </div>
    </div>
  );
};

export default CartProductStep;